import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
const Heading = [['Warehouse',  'Brand',  'Retailer Name',  'Bill No.', 'Bill date',  'Prod Code',  'Prod Desc',  'Mrp',  'Order Qty','Dispatch Qty', 'Dues Qty'
]];





class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchCycleCountData = this.fetchCycleCountData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no : "",
      trip_id : "",
      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,
      from_date: "",
      to_date: "",
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      retailer_code : "",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };
  
  onRetailerChange = (evt)=>{
    this.setState({
      retailer_code : evt.target.value,
    })
  }

  fetchCycleCountData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      retailer_code : this.state.retailer_code,
    };
    addAnalytics('Report', 'View Dues Report', payload);
    API.post('/reports/dues_report', { param: payload })
      .then(response => response.data)

      .then(data => {

        console.log(data);

        this.setState({ tableRows: this.assemblePosts(data.data)})

      })

      .then(async () => {

        this.setState({  isLoading: false ,loading_overlay: false})

       

      });
  }

  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      return (

        {
          warehouse: post.warehouse,
          brand : post.brand,
          retailer_name: post.retailer_name,
          bill_no : post.bill_number,
          bill_date : post.bill_date, 
          product_code: post.product_code,
          prod_desc: post.product_desc,	
          mrp: post.mrp,
          order_qty : post.order_qty,
          dispatch_qty:  post.dispatched_qty,	
          dues_qty : post.dues_qty,
          

        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      orderData : posts,
      filtered_orderData : posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: ' Warehouse',
          field: 'warehouse',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Brand',
          field: 'brand',
          sort: 'asc',
          width: 100,

        },
        {
          label: 'Retailer Name',
          field: 'retailer_name',
          sort: 'asc',
          width: 130,

        },
        {

          label: 'Bill No',
          field: 'bill_no',
          width: 120,
          sort: 'asc',

        }, 
        {
          label: 'Bill Date',
          field: 'bill_date',
          sort: 'asc',
          width: 150,

        },

        {
          label: 'Prod Code',
          field: 'product_code',
          width: 130,
          sort: 'asc',

        },
        {

          label: 'Prod Desc',
          field: 'prod_desc',
          width: 150,
          sort: 'asc',

        },

        {
          label: 'MRP',
          field: 'mrp',
          width: 90,
          sort: 'asc',

        },
        {
          label : 'Order Qty',
          field : 'order_qty',
          width :  120,
          sort  : 'asc'

        },
        {
          label : 'Dispatch Qty',
          field : 'dispatch_qty',
          width :  120,
          sort  : 'asc'

        },

        {

          label: 'Dues Qty',
          field: 'dues_qty',
          width: 110,
          sort: 'asc',

        },


      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <Overlay>
          <form className="form" >
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title"> From Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={this.state.from_date}
                    onChange={this.FromDateChange}
                    className="ledger_fromdate"
                    placeholderText="From Date"
                    format='yyyy-MM-dd'

                  />

                  {this.state.showFromErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                  }
                  {this.state.dateOrderError && (
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                  )}
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title"> To Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={this.state.to_date}
                    onChange={this.ToDateChange}
                    className="ledger_todate"
                    placeholderText="To Date"
                  />
                  {this.state.showToErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                  }
                  {this.state.dateRangeError &&
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                  }
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title"> Retailer Code</span>
                <div style={{ position: 'relative' }}>
                  <input type = "text" style={{height: 38}} className="form-control" placeholder= "Retailer Code" onChange={this.onRetailerChange}/>
                </div>
              </div>
              
              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchCycleCountData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>


                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, "Dues Report", Heading)}
                    >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>
          {!this.state.showFetchBinData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}

          {this.state.showFetchBinData && (
            <div>
              <div>
                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                }

                {to_Date_val &&
                  <div className="date-container">
                   {to_Date_val}
                  </div>
                }

                {this.state.retailer_code &&
                  <div className="date-container">
                   {this.state.retailer_code}
                  </div>
                } 
              </div>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
               
                  <MDBDataTable
                    striped
                    bordered
                    scrollX
                    sortable={false}
                    onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'View Dues Report', 'datatable_pagination_change' )}
                    hover
                    onSearch={this.filterData}
                    data={data}
                    // style={{ textAlign: "center" }}
                  />
                </div>
              </div>
            </div>

          )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));